import PropTypes from 'prop-types';
import { useGetImgixImageUrl } from '../../../../../../hooks';
import { useShowBackgroundVideo } from '../../hooks/useShowBackgroundVideo';
import {
  BackgroundVideo,
  HeroModuleCallToAction,
  HeroModuleText,
  HeroModuleTitle,
} from '../../innerComponents';
import HeroModuleSummary from '../../innerComponents/HeroModuleSummary';
import { Wrapper } from './Wrapper';
import { Column } from './Column';
import styled from 'styled-components';

const VenueWrapper = styled.div`
  text-transform: uppercase;
`;

export function BackgroundFiftyFiftyDisplayContent(props) {
  const {
    section: {
      valueProposition: title,
      titleSize,
      text,
      primaryLink: primaryCTAConfig = {},
      secondaryLink: secondaryCTAConfig = {},
      thirdLink: thirdCTAConfig = {},
      fourthLink: fourthCTAConfig = {},
      additionalCallToActions,
      displayDataAndVenueInfo,
      background,
      backgroundType,
      videoId,
      videoSource,
      playVideoOnMobile,
      type,
      displayType,
    },
  } = props;

  const backgroundImagePath = useGetImgixImageUrl(background?.path);
  const showBackgroundVideo = useShowBackgroundVideo(
    videoId,
    playVideoOnMobile,
  );

  return (
    <Wrapper className="lazy" data-background-image={backgroundImagePath}>
      {showBackgroundVideo && backgroundType === 'VIDEO' && (
        <BackgroundVideo
          videoId={videoId}
          videoSource={videoSource}
          withTransparentOverlay
        />
      )}
      <Column className="content">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-lg-8 col-lg-offset-2">
              {displayDataAndVenueInfo && (
                <VenueWrapper>
                  <HeroModuleSummary />
                </VenueWrapper>
              )}
              <HeroModuleTitle as={titleSize} text={title} styled />
              <HeroModuleText text={text} />
              <HeroModuleCallToAction
                primaryCTAConfig={primaryCTAConfig}
                secondaryCTAConfig={secondaryCTAConfig}
                thirdCTAConfig={thirdCTAConfig}
                fourthCTAConfig={fourthCTAConfig}
                additionalCallToActions={additionalCallToActions}
                moduleType={type}
                displayType={displayType}
              />
            </div>
          </div>
        </div>
      </Column>
      <Column className="background" />
    </Wrapper>
  );
}

BackgroundFiftyFiftyDisplayContent.propTypes = {
  section: PropTypes.shape({
    valueProposition: PropTypes.string,
    titleSize: PropTypes.string,
    text: PropTypes.string,
    primaryLink: PropTypes.object,
    secondaryLink: PropTypes.object,
    thirdLink: PropTypes.object,
    fourthLink: PropTypes.object,
    additionalCallToActions: PropTypes.bool,
    displayDataAndVenueInfo: PropTypes.bool,
    background: PropTypes.object,
    backgroundType: PropTypes.string,
    videoId: PropTypes.string,
    videoSource: PropTypes.string,
    playVideoOnMobile: PropTypes.bool,
  }).isRequired,
};
